<template>
  <div class="news">
    <HeaderNav :current="current" :titleMsg='titleMsg'></HeaderNav>
    <div class="news-content w1200">
      <div class="text">
        <!-- <p>首页/新闻</p> -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <!-- <el-breadcrumb-item><a href="/">活动管理</a></el-breadcrumb-item> -->
          <el-breadcrumb-item>协会简介</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="content" ref="anyway" v-html="assoDesc.content">

        </div>
    </div>
    <div class="fixd">
      <CopyRight></CopyRight>
    </div>
  </div>
</template>

<script>
import { queryAssoDesc } from '@/api/association'
import HeaderNav from '@/components/common/HeaderNav/HeaderNav'
import CopyRight from '@/components/common/CopyRight/CopyRight'
import {formatDate} from '@/components/common/config/formatTime.js'
export default {
  name: 'tabs',
  components: {
    HeaderNav,
    CopyRight
  },
  data () {
    return {
      current: 6,
      loading: false,
      assoDesc: {},
      pageNum: 1,
      pageSize: 6,
      total: null,
      type: this.$route.params.type,
      currentPage: 1,
      titleMsg: '协会简介'
    }
  },
  methods: {
    formatDate,
    getQueryAssoDesc () {
      let that = this
      console.log(that.loading)
      queryAssoDesc({ assoId: localStorage.getItem('assoId') }).then(res => {
        if (res.data.status === 0) {
          // that.list = res.data.data.list
          console.log(res.data.data.list)
          that.assoDesc = res.data.data
          that.$nextTick(function () {
            that.reverPptUrl()
          // Code that will run only after the
          // entire view has been rendered
          })
        }
      })
      // that.loading = true
    },
    // ppt添加缩略图样式
    reverPptUrl: function () {
      let pptArr = this.$refs.anyway.getElementsByTagName('img')
      if (pptArr.length > 0) {
        console.log(pptArr.length)
        for (let i = 0; i < pptArr.length; i++) {
        // let pptEl = pptArr[i].src
          let NewPptUrl = 'width:100%;display:block;'
          pptArr[i].setAttribute('style', NewPptUrl)
        // console.log(NewPptUrl)
        }
      }
    }
  },
  mounted () { // 这里必须是mouted钩子
    // 下拉加载更多监听滚轮
    // window.addEventListener('scroll', this.handleScroll, true) // 监听（绑定）滚轮 滚动事件
  },
  created () {
    this.getQueryAssoDesc()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
  .news {
    width: 100%;
    background-color: #fff;
  }

  .news-content {
    width: 1100px;
    padding: 20px 50px 150px 50px;
    background: #f3f3f3;
    border-radius: 10px;
    margin-top: 20px;
  }
  .content{
    /* margin-top:10px; */
    width: 800px;
    margin: 20px auto 0px auto;
  }
  .content img{
     width: 100%!important;
  }
  .clum {
    overflow: hidden;
    padding: 35px 0px;
  }

  .clum .icon {
    display: inline-block;
    font-size: 24px;
    font-weight: bold;
    background-position: 0px center;
    background-repeat: no-repeat;
    background-size: 5px 24px;
    background-image: url(../../../static/images/nwe-shuxian.png);
    padding-left: 14px;
    font-style: normal;
  }

  .clum span {
    float: right;
    font-size: 16px;
    color: #888;
    line-height: 30px;
    cursor: pointer;
  }
  .text {
    border-radius: 5px;
    background: #fff;
    margin-top: 30px;
    padding: 20px 10px;
    border-bottom: 1px solid #f6f6f6;
  }
  .text p {
    font-size: 14px;
    color:#888;
    padding: 15px;
  }

  .fixd {
    width: 100%;
    position: fixed;
    bottom: 0px;
    left: 0px;
    z-index: 99999;
  }
</style>



// WEBPACK FOOTER //
// src/components/aboutAsso/AboutAsso.vue